import * as React from 'react';

import {Popover} from 'shells/popover/popover';

import type {View, SelectFieldInput} from '../../../../types';

import {FieldCards} from './field-cards';
import {MoreFieldsButton} from './more-fields-button';

type Props = {
    hasCompanyNameField: boolean;
    onSelectInputField: (arg1: SelectFieldInput) => void;
    setCurrentView: (newView: View) => void;
};

export function StandardFields(props: Props) {
    const [popoverAnchor, setPopoverAnchor] = React.useState<any>(null);
    const [popoverContent, setPopoverContent] = React.useState<any>(null);

    const onShowPersonNamePopover = (e: React.SyntheticEvent<any>) => {
        setPopoverAnchor(e.target);
        setPopoverContent(
            <div>
                The <strong>name</strong> field has been added to your form
            </div>
        );
    };
    const onShowCompanyNamePopover = (e: React.SyntheticEvent<any>) => {
        setPopoverAnchor(e.target);
        setPopoverContent(
            <div>
                The <strong>company name</strong> field has been added to your form
            </div>
        );
    };
    const onRemovePopover = () => {
        setPopoverAnchor(null);
        setPopoverContent(null);
    };

    const companyNameIsDisabled = props.hasCompanyNameField;

    return (
        <>
            <FieldCards
                personNameIsDisabled={true}
                companyNameIsDisabled={companyNameIsDisabled}
                onShowPersonNamePopover={onShowPersonNamePopover}
                onShowCompanyNamePopover={onShowCompanyNamePopover}
                onRemovePopover={onRemovePopover}
                nameCardText='Name'
                nameCardFieldKey='name'
                onSelectInputField={props.onSelectInputField}
                setCurrentView={props.setCurrentView}
            />
            <MoreFieldsButton setCurrentView={props.setCurrentView} />
            {popoverAnchor ? (
                <Popover anchor={popoverAnchor} isDialog={true}>
                    {popoverContent}
                </Popover>
            ) : undefined}
        </>
    );
}
